// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, number, object, oneOfType, string } from 'prop-types'

class GenericTooltipTrigger extends React.Component {
  static propTypes = {
    assignTooltip: func.isRequired,
    children: object.isRequired,
    idRoot: string.isRequired,
    tooltipColumn: string.isRequired,
    tooltipId: string.isRequired,
    tooltipData: oneOfType([
      array,
      number,
      object,
      string,
    ]),
  }

  onMouseOver = () => {
    const {
      assignTooltip,
      tooltipColumn,
      tooltipData,
    } = this.props

    assignTooltip(tooltipColumn, tooltipData)
  }

  render () {
    const {
      children,
      idRoot,
      tooltipId,
    } = this.props

    return (
      <p
        className={'data-table-generic-tooltip-trigger'}
        data-class={'project-summary-tooltip tooltip-wrapper'}
        data-for={tooltipId}
        data-tip={true}
        id={`${idRoot}-tooltip-trigger`}
        onMouseOver={this.onMouseOver}>
        {children}
      </p>
    )
  }
}

export default GenericTooltipTrigger
